import React, { Component } from "react";
import { setPageCrashedStatus } from "../../helper";
import PageCrash from "./pageCrash";

export class ErrorBoundary extends Component {
  state = {
    error: null,
    errorInfo:null
  };
  componentDidCatch(error, errorInfo) {
    this.setState({ error,errorInfo });
  }
  componentDidUpdate(prevProps, prevState) {
    if (!prevState.error && this.state.error) {
      setPageCrashedStatus(true);
    } else if (prevState.error && !this.state.error) {
      setPageCrashedStatus(false);
    }
  }
  componentWillUnmount() {
    setPageCrashedStatus(false);
  }
  render() {
    if (this.state.error ) {
      return (
        <PageCrash error={this.state.error} info={this.state.errorInfo}/>
      );
    } else {
        // alert('child')
      //when there's not an error, render children untouched
      return this.props.children
    }
  }
}
